import httpClient from '../lib/httpClient';

/**
 * Service for managing customer accounts and their product operations.
 */

/**
 * Get account balance by code (from QR scan)
 * Uses /api endpoint (accessible by operators and admins)
 * @param {string} code - Account code from QR
 * @returns {Promise<Object>} Balance data with products
 */
export const getAccountBalance = async (code) => {
  const response = await httpClient.get(`api/accounts/code/${encodeURIComponent(code)}/balance`);
  return response.data;
};

/**
 * Get account operations history
 * Uses /api endpoint (accessible by operators and admins)
 * @param {string} code - Account code
 * @param {Object} params - Query parameters
 * @returns {Promise<Object>} Operations list
 */
export const getAccountOperations = async (code, params = {}) => {
  const response = await httpClient.get(`api/accounts/code/${encodeURIComponent(code)}/operations`, {
    query: params
  });
  return response;
};

/**
 * Deliver a product to an account
 * Uses /api endpoint (accessible by operators and admins)
 * @param {string} code - Account code
 * @param {Object} payload - { product_id, quantity, notes }
 * @returns {Promise<Object>} Operation result
 */
export const deliverProduct = async (code, payload) => {
  const response = await httpClient.post(
    `api/accounts/code/${encodeURIComponent(code)}/deliver`,
    payload
  );
  return response;
};

/**
 * Reverse a delivery operation
 * Uses /api endpoint (accessible by operators and admins)
 * @param {string} code - Account code
 * @param {Object} payload - { operation_id, notes }
 * @returns {Promise<Object>} Reversal result
 */
export const reverseOperation = async (code, payload) => {
  const response = await httpClient.post(
    `api/accounts/code/${encodeURIComponent(code)}/operations/reverse`,
    payload
  );
  return response;
};

const accountService = {
  getAccountBalance,
  getAccountOperations,
  deliverProduct,
  reverseOperation
};

export default accountService;
